import * as React from 'react';
import { cn } from 'shared/src/utils';
import { cva, type VariantProps } from 'class-variance-authority';
import { twMerge } from 'tailwind-merge';

export const inputVariants = cva(
  'h-8 w-full placeholder:text-sm text-sm rounded-md border border-input focus:border-input bg-background px-3 file:py-1 text-foreground transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
  {
    variants: {
      variant: {
        default: '',
        invisible:
          'border-none ring-0 focus:ring-2 focus:border focus:border-input focus-visible:outline-none ring-inset p-1 text-right placeholder:text-right pr-0 focus:pr-3 -ml-0.5 placeholder:italic focus:placeholder:text-white disabled:opacity-100',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
);

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement>, VariantProps<typeof inputVariants> {}

const Input = React.forwardRef<HTMLInputElement, InputProps>(({ className, type, variant, ...props }, ref) => {
  return <input type={type} className={twMerge(cn(inputVariants({ variant, className })))} ref={ref} {...props} />;
});
Input.displayName = 'Input';

export { Input };
